import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { setModalMetadata } from '@/features/ui/ui-slice'

export default function useModalMetadata(metadata: any = {}) {
  const dispatch = useDispatch()
  const { titleContent = {} } = metadata

  const dispatchModalTitle = useCallback(
    (newTitleContent) => {
      dispatch(
        setModalMetadata({
          titleContent: newTitleContent,
        }),
      )
    },
    [dispatch],
  )

  const { id: titleContentId, variables: titleContentVariables = {} } = titleContent
  const titleContentVariableList = Object.keys(titleContentVariables)
  const [firstTitleVariableName] = titleContentVariableList
  const firstTitleVariableValue = titleContentVariables[firstTitleVariableName]
  // Note: Title dynamic variable values are memoized for performance also to avoid rerender.
  // In order to support additional variables, we have to memoize them.
  const titleContentValues = useMemo(() => {
    return {
      [firstTitleVariableName]: firstTitleVariableValue,
    }
  }, [firstTitleVariableName, firstTitleVariableValue])

  useEffect(() => {
    if (titleContentId) {
      dispatchModalTitle({
        id: titleContentId,
        values: titleContentValues,
      })
    }
  }, [titleContentId, titleContentValues, dispatchModalTitle])

  return useMemo(() => {
    return {
      setModalTitle: dispatchModalTitle,
    }
  }, [dispatchModalTitle])
}
